// Team Member detail page (CHG-1249 / ITER-3373).
//
// Thin per v2-canary: configuration in @generated/screens. Future generator
// regenerates teamMemberDetailConfig from account.entity-hint.yaml.
//
// Spec: specs/tier-05-experience/team-member-detail-v2.cross-screen.yaml.

import { DetailPage } from "../components/composition";
import { teamMemberDetailConfig } from "../generated/screens/team-member-detail";

export function TeamMemberDetail() {
  return <DetailPage config={teamMemberDetailConfig} />;
}
